import TemplateView from '../../TemplateView'
import Toast from './Toast'
import {arrayToSet} from '../../atUtils'
import {connect} from '../../redux/utils'
import {getMessages} from '../selectors'
import {bindActionCreators} from 'redux'
import {closeToast} from '../actions'

export class ToastsContainer extends TemplateView {
    constructor({
        closeToast,
    }) {
        super()

        this.actions = {
            closeToast,
        }

        this.state = {
            messages: []
        }

        this.toasts = {}

        this.onStatePropertyDeeplyChanged('messages', (newMessages, oldMessages = []) => {
            const newMessagesIds = arrayToSet(newMessages.map(m => m.id))
            const oldMessagesIds = arrayToSet(oldMessages.map(m => m.id))

            newMessages.forEach(newMessage => {
                if (!oldMessagesIds[newMessage.id]) {
                    this.toasts[newMessage.id] = new Toast({
                        innerHtml: newMessage.html,
                        additionalClass: newMessage.isWarning ? 'warning' : '',
                        withCloseIcon: newMessage.isWarning,
                        onClose: () => this.actions.closeToast(newMessage.id)
                    }).init(this.$el)
                }
            })

            oldMessages.forEach(oldMessage => {
                if (!newMessagesIds[oldMessage.id]) {
                    this.toasts[oldMessage.id].hide()
                    delete this.toasts[oldMessage.id]
                }
            })
        })
    }

    templateHtml() {
        return "<div class='toastsContainer'></div>"
    }
}

export default connect(
    state => ({
        messages: getMessages(state)
    }),
    dispatch => ({
        closeToast: bindActionCreators(closeToast, dispatch)
    })
)(ToastsContainer)



// WEBPACK FOOTER //
// ./web/js/toasts/components/ToastsContainer.js